import IconButton, { type IconButtonProps } from "@mui/material/IconButton";
import { Link } from "react-router";

export const LinkIconButton = ({ children, ...rest }: IconButtonProps<typeof Link, { component?: typeof Link }>) => {
  return (
    <IconButton component={Link} {...rest}>
      {children}
    </IconButton>
  );
};
